import PropTypes from "prop-types";
import {
  Box,
  Typography,
  Card,
  CardContent,
  FormGroup,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { formatDoisDigitos } from "../../Components/Funcionais/Utils";

const UserProdutividadeHora = ({
  dataProd,
  setHora,
  diaProdHora,
  handleExibirVideos,
  exibeVideos,
  setAbrirVideo,
  abrirVideo,
}) => {

  const chartOptions = {
    chart: {
      type: "bar",
      height: 350,
      toolbar: { show: false },
      background: "transparent",
      events: {
        dataPointSelection: (event, chartContext, config) => {
          const dataPointIndex = config.dataPointIndex;
          if (dataProd && dataProd[dataPointIndex]) {
            if (exibeVideos) {
              setHora(formatDoisDigitos(dataProd[dataPointIndex].hora));
              setAbrirVideo(!abrirVideo);
            } else {
              setHora("00");
            }
          }
        },
      },
    },
    colors: ["#647DEE", "#f44336"],
    fill: {
      type: ["gradient", "solid"],
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.3,
        gradientToColors: ["#1A3865"],
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 0.85,
      },
    },
    stroke: {
      width: [0, 3],
      curve: "smooth",
    },
    markers: {
      size: [0, 4],
    },
    plotOptions: {
      bar: {
        borderRadius: 8,
        dataLabels: { position: "top" },
        columnWidth: "65%",
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val, { seriesIndex }) => {
        if (seriesIndex === 0) return `${Number(val).toFixed(0)}%`;
        if (seriesIndex === 1) return `${Number(val).toFixed(0)}`;
        return val;
      },
      offsetY: -4,
      style: {
        fontSize: "10px",
        fontWeight: 700,
        colors: ["#1A3865", "#b71c1c"],
      },
    },
    grid: {
      borderColor: "#e0e7ff",
      strokeDashArray: 4,
      padding: { top: 0, right: 10, bottom: 0, left: 10 },
    },
    xaxis: {
      categories: dataProd.length > 0 ? dataProd.map((item) => `${item.hora}h`) : [],
      position: "bottom",
      axisBorder: { show: false },
      axisTicks: { show: false },
      tooltip: { enabled: false },
      labels: {
        style: {
          fontSize: "10px",
          colors: "#6b7a99",
          fontWeight: 500,
        },
      },
    },
    yaxis: [
      {
        max: 100,
        min: 0,
        labels: {
          formatter: (val) => `${val.toFixed(0)}%`,
          style: { colors: "#6b7a99", fontSize: "11px" },
        },
        title: {
          text: "Aproveitamento",
          style: {
            fontSize: "11px",
            fontWeight: 700,
            color: "#1A3865",
            fontFamily: "inherit",
          },
        },
        axisBorder: { show: false },
        axisTicks: { show: false },
      },
      {
        opposite: true,
        labels: {
          formatter: (val) => `${val.toFixed(0)}`,
          style: { colors: "#6b7a99", fontSize: "11px" },
        },
        title: {
          text: "Teclas por Hora",
          style: {
            fontSize: "11px",
            fontWeight: 700,
            color: "#f44336",
            fontFamily: "inherit",
          },
        },
      },
    ],
    tooltip: {
      theme: "light",
    },
    legend: {
      labels: {
        colors: ["#1A3865", "#f44336"],
      },
    },
    title: { text: "" },
  };

  useEffect(() => {
    if (!exibeVideos) {
      setAbrirVideo(false);
    }
  }, [exibeVideos]);

  useEffect(() => {}, [dataProd]);

  return (
    <Box sx={{ width: "100%", mt: 2, position: "relative" }}>
      <Card sx={{
        width: "100%",
        boxShadow: "0 8px 28px rgba(26, 56, 101, 0.12), 0 2px 6px rgba(100,125,238,0.08)",
        borderRadius: "16px",
        border: "1px solid rgba(100, 125, 238, 0.15)",
        overflow: "hidden",
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0, left: 0, right: 0,
          height: "4px",
          background: "linear-gradient(90deg, #647DEE, #1A3865, #269FFB)",
        },
      }}>
        <CardContent sx={{ pt: 3, pb: "52px !important" }}>
          <Typography gutterBottom align="center" sx={{
            fontWeight: 700,
            fontSize: "1rem",
            color: "#1A3865",
            letterSpacing: "0.4px",
          }}>
            Aproveitamento em {diaProdHora}
          </Typography>
          <ReactApexChart
            options={chartOptions}
            series={[
              {
                name: "Aproveitamento",
                data: dataProd.map((item) => item.produtividade),
              },
              {
                name: "Teclas por Hora",
                type: "line",
                data: dataProd.map((item) => Number(item.teclasDigitadas) ?? 0),
                yaxis: 1,
              },
            ]}
            type="bar"
            height={350}
          />
        </CardContent>
      </Card>
      <FormGroup
        sx={{
          position: "absolute",
          bottom: 12,
          left: 16,
          zIndex: 1,
        }}
      >
        <FormControlLabel
          control={
            <Switch
              checked={exibeVideos}
              onChange={handleExibirVideos}
              color="primary"
              size="small"
            />
          }
          label={
            <Typography variant="caption" sx={{ color: "#6b7a99", fontWeight: 500 }}>
              Exibir vídeos ao clicar na barra
            </Typography>
          }
        />
      </FormGroup>
    </Box>
  );
};

UserProdutividadeHora.propTypes = {
  dataProd: PropTypes.array,
  setHora: PropTypes.func,
  diaProdHora: PropTypes.object,
  handleExibirVideos: PropTypes.func,
  exibeVideos: PropTypes.bool,
  setAbrirVideo: PropTypes.func,
  abrirVideo: PropTypes.bool,
};

export default UserProdutividadeHora;
